"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetGroupFragmentDependencies = exports.targetGroupFragment = void 0;
const emailTargetFragment_1 = require("./emailTargetFragment");
const smsTargetFragment_1 = require("./smsTargetFragment");
const telegramTargetFragment_1 = require("./telegramTargetFragment");
exports.targetGroupFragment = `
fragment targetGroupFragment on TargetGroup {
  id
  name
  emailTargets {
    ...emailTargetFragment
  }
  smsTargets {
    ...smsTargetFragment
  }
  telegramTargets {
    ...telegramTargetFragment
  }
}
`.trim();
exports.targetGroupFragmentDependencies = [
    ...emailTargetFragment_1.emailTargetFragmentDependencies,
    ...smsTargetFragment_1.smsTargetFragmentDependencies,
    ...telegramTargetFragment_1.telegramTargetFragmentDependencies,
    emailTargetFragment_1.emailTargetFragment,
    smsTargetFragment_1.smsTargetFragment,
    telegramTargetFragment_1.telegramTargetFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFyZ2V0R3JvdXBGcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvdGFyZ2V0R3JvdXBGcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrREFHK0I7QUFDL0IsMkRBRzZCO0FBQzdCLHFFQUdrQztBQUVyQixRQUFBLG1CQUFtQixHQUFHOzs7Ozs7Ozs7Ozs7OztDQWNsQyxDQUFDLElBQUksRUFBRSxDQUFDO0FBRUksUUFBQSwrQkFBK0IsR0FBRztJQUM3QyxHQUFHLHFEQUErQjtJQUNsQyxHQUFHLGlEQUE2QjtJQUNoQyxHQUFHLDJEQUFrQztJQUNyQyx5Q0FBbUI7SUFDbkIscUNBQWlCO0lBQ2pCLCtDQUFzQjtDQUN2QixDQUFDIn0=